import axios from 'axios'
// import { toast } from 'sonner';

const request = axios.create({
    baseURL: "https://api.signalare.com/api/"
    // baseURL: "https://localhost:44341/api/" 
})

request.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // 🔒 Usuario no autenticado
      //   toast.error("No autenticado, debe iniciar sesión.")      
    }
    return Promise.reject(error);
  }
);

export const petitions = {};

petitions.login = async (user, pass) => {   
    try {
        const response = await request.post('Login/Auth', {
            Username: user,
            Password: pass
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getUsuario = async (idUser,token) => {
    try {
        const response = await request.get('Usuario/GetUsuario', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idUsuario: idUser
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getEmpresas = async (idUser,token) => {
    try {
        const response = await request.get('Empresa/GetEmpresas', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idUsuario: idUser
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getEmpresa = async (idEmpresa,token) => {
    try {
        const response = await request.get('Empresa/GetEmpresa', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getNodosP = async (idEmpresa,token) => {
    try {
        const response = await request.get('Usuario/GetNodosPrincipales', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getPermisos = async (idUsuario,idEmpresa,token) => {
    try {
        const response = await request.get('Usuario/GetPermisos', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idUsuario: idUsuario,
                idEmpresa: idEmpresa
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getAreas = async (idEmpresa,token) => {
    try {
        const response = await request.get('Archivo/GetArea', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.insertArea = async (idEmpresa,token,data) => {
    try {
        const response = await request.post('Archivo/InsertArea',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.deleteArea = async (idEmpresa,token,data) => {
    try {
        const response = await request.delete('Archivo/DeleteArea',{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
            data: data
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getLocal = async (idEmpresa,token) => {
    try {
        const response = await request.get('Archivo/GetLocal', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.insertLocal = async (idEmpresa,token,data) => {
    try {
        const response = await request.post('Archivo/InsertLocal',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.deleteLocal = async (idEmpresa,token,data) => {
    try {
        const response = await request.delete('Archivo/DeleteLocal',{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
            data: data
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getTPago = async (idEmpresa,token) => {
    try {
        const response = await request.get('Archivo/GetTPago', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.insertTPago = async (idEmpresa,token, data) => {
    try {
        const response = await request.post('Archivo/InsertTPago',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.deleteTPago = async (idEmpresa,token, data) => {
    try {
        const response = await request.delete('Archivo/DeleteTPago',{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
            data: data
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.updateTPago = async (idEmpresa,token, data) =>{
    try {
        const response = await request.put('Archivo/UpdateTPago',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getMarca = async (idEmpresa,token) => {
    try {
        const response = await request.get('Archivo/GetMarca', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.insertMarca = async (idEmpresa,token, data) => {
    try {
        const response = await request.post('Archivo/InsertMarca',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.deleteMarca = async (idEmpresa,token, data) => {
    try {
        const response = await request.delete('Archivo/DeleteMarca',{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
            data: data
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getModeloMarca = async (idEmpresa,token) => {
    try {
        const response = await request.get('Archivo/GetModeloMarca', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.insertModeloMarca = async (idEmpresa,token, data) => {
    try {
        const response = await request.post('Archivo/InsertModeloMarca',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.deleteModeloMarca = async (idEmpresa,token, data) => {
    try {
        const response = await request.delete('Archivo/DeleteModeloMarca',{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
            data: data
        })
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.getAlmacen = async (idEmpresa,token) =>{
    try {
        const response = await request.get('Archivo/GetAlmacen', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.insertAlmacen = async (idEmpresa,token,data) => {
    try {
        const response = await request.post('Archivo/InsertAlmacen',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.updateAlmacen = async (idEmpresa,token,data) => {
    try {
        const response = await request.put('Archivo/UpdateAlmacen',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.deleteAlmacen = async (idEmpresa,token, data) => {
    try {
        const response = await request.delete('Archivo/DeleteAlmacen',{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
            data: data
        })
        return response.data;        
    } catch (error) {
        return error;
    }
}

petitions.getMedida = async (idEmpresa,token) => {
    try {
        const response = await request.get('Archivo/GetMedida', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
        });
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.insertMedida = async (idEmpresa,token,data) => {
    try {
        const response = await request.post('Archivo/InsertMedida',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;  
    } catch (error) {
        return error;
    }
}

petitions.updateMedida = async (idEmpresa,token,data) => {
    try {
        const response = await request.put('Archivo/UpdateMedida',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.deleteMedida = async (idEmpresa,token,data) => {
    try {
        const response = await request.delete('Archivo/DeleteMedida',{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
            data: data
        })
        return response.data;          
    } catch (error) {
        return error;
    }
}

petitions.getCategoria = async (idEmpresa,token) => {
    try {
        const response = await request.get('Productos/GetCategoria', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
        });
        return response.data;               
    } catch (error) {
        return error;
    }
}

petitions.getTPServicio = async (idEmpresa,token) => {
    try {
        const response = await request.get('Productos/GetTPServicio', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.insertPServicio = async (idEmpresa,token, data) => {
    try {
        const response = await request.post('Productos/InsertProducto',data,{
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;         
    } catch (error) {
        return error;
    }
}

petitions.getProductos = async (idEmpresa, token, data) => {
  try {
    const response = await request.post(
      "Productos/GetProductos",
      data ?? {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          idEmpresa,
        },
      }
    );

    return response.data;
  } catch (error) {
    return error;
  }
};

petitions.updatePServicio = async (idEmpresa,token, data) =>{
    try {
        const response = await request.put('Productos/UpdatePServicio',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.deletePServicio = async (idEmpresa,token, data) => {
    try {
        const response = await request.delete('Productos/DeleteProducto',{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
            data: data
        })
        return response.data;        
    } catch (error) {
        return error;
    }
}

petitions.UpdatePServicioStatus = async (idEmpresa,token, data) =>{
    try {
        const response = await request.put('Productos/UpdatePServicioStatus',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.insertCategoria = async (idEmpresa,token, data) => {
    try {
        const response = await request.post('Productos/InsertCategoria',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;         
    } catch (error) {
        return error;
    }
}

petitions.deleteCategoria = async (idEmpresa,token, data) =>{
    try {
        const response = await request.delete('Productos/DeleteCategoria',{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
            data: data
        })
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.insertTPServicio = async (idEmpresa,token, data) => {
    try {
        const response = await request.post('Productos/InsertTPServicio',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.deleteTPServicio = async (idEmpresa,token, data) => {
    try {
        const response = await request.delete('Productos/DeleteTPServicio',{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
            data: data
        })
        return response.data;       
    } catch (error) {
        return error;
    }
}

//SELECTS PARA CLIENTE
petitions.getRubroContribuyente = async (idEmpresa,token) => {
    try {
        const response = await request.get('Clientes/GetRubroContribuyente', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
        });
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.getTPersona = async (idEmpresa,token) => {
    try {
        const response = await request.get('Select/GetTPersona', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
        });
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.getTDIdentidad = async (idEmpresa,token) => {
    try {
        const response = await request.get('Select/GetTDIdentidad', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
        });
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.getPais = async (idEmpresa,token) => {
    try {
        const response = await request.get('Select/GetPais', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
        });
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.getDistrito = async (idEmpresa,token) => {
    try {
        const response = await request.get('Select/GetDistrito', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
        });
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.getProvincia = async (idEmpresa,token) => {
    try {
        const response = await request.get('Select/GetProvincia', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
        });
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.getMoneda = async (idEmpresa,token) => {
    try {
        const response = await request.get('Select/GetMoneda', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
        });
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.getRegion = async (idEmpresa, token)=>{
    try {
        const response = await request.get('Select/GetRegion', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
        });
        return response.data;       
    } catch (error) {
        return error;
    }
}

//CONSULTAR DNI/RUC
petitions.getDni = async (dni, token) =>{
    try {
        const response = await request.get('Sunat/GetDni', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                dni: dni
            },
        });
        return response;       
    } catch (error) {
        return error;
    }
}

petitions.getRuc = async (ruc, token) =>{
    try {
        const response = await request.get('Sunat/GetRuc', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                ruc: ruc
            },
        });
        return response;       
    } catch (error) {
        return error;
    }
}

petitions.insertClienteData = async (idEmpresa,token,data) =>{
    try {
        const response = await request.post('Clientes/InsertClienteData',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;        
    } catch (error) {
        return error;
    }
}

petitions.getClientes = async (idEmpresa, token, data) => {
    try {

        const response = await request.post(
            'Clientes/GetClientes',
            data ?? {},
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                params: {
                    idEmpresa
                }
            }
        );

        return response.data;

    } catch (error) {
        return error;
    }
}

petitions.deleteCliente = async (idEmpresa,token, data) =>{
    try {
        const response = await request.delete('Clientes/DeleteCliente',{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
            data: data
        })
        return response.data;              
    } catch (error) {
        return error;
    }
}

petitions.updateCliente = async (idEmpresa,token, data) =>{
    try {
        const response = await request.put('Clientes/UpdateCliente',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data; 
    } catch (error) {
        return error;
    }
}

petitions.getVehiculos = async (idEmpresa,token) => {
    try {
        const response = await request.get('Archivo/GetVehiculo', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.insertVehiculo = async (idEmpresa,token,data) => {
    try {
        const response = await request.post('Archivo/InsertVehiculo',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;    
    } catch (error) {
        return error;
    }
}

petitions.deleteVehiculo = async (idEmpresa,token, data) => {
    try {
        const response = await request.delete('Archivo/DeleteVehiculo',{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
            data: data
        })
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.updateVehiculo = async (idEmpresa,token, data) => {
    try {
        const response = await request.put('Archivo/UpdateVehiculo',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data; 
    } catch (error) {
        return error;
    }
}

petitions.getClientesSelect = async (idEmpresa,token) => {
    try {
        const response = await request.get('Clientes/GetClienteSelect', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.insertVenta = async (idEmpresa,token,data) =>{
    try {
        const response = await request.post('Venta/RegisterVenta',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;  
    } catch (error) {
        return error;
    }
}

petitions.getProductsType = async (idEmpresa,token, typeProduct) =>{
    try {
        const response = await request.get('Productos/GetProductoTipo', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa,
                tipo: typeProduct
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getMedPagos = async (idEmpresa,token) => {
    try {
        const response = await request.get('Archivo/GetMedPago', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getVentas = async (idEmpresa,token, fInicio, fFin) => {
    try {
        const response = await request.get('Venta/GetVentas', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa,
                fInicio: fInicio,
                fFin: fFin
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getVenta = async (idEmpresa,token, idVenta ) => {
    try {
        const response = await request.get('Venta/GetVenta', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa,
                idVenta: idVenta
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.insertCotizacion = async (idEmpresa,token,data) =>{
    try {
        const response = await request.post('Venta/RegisterCotizacion',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;  
    } catch (error) {
        return error;
    }
}

petitions.getCotizaciones = async (idEmpresa,token, fInicio, fFin ) => {
    try {
        const response = await request.get('Venta/GetCotizaciones', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa,
                fInicio: fInicio,
                fFin: fFin
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getCotizacion = async (idEmpresa,token, idCotizacion ) => {
    try {
        const response = await request.get('Venta/GetCotizacion', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa,
                idVenta: idCotizacion
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.updateCotizacion = async (idEmpresa,token,data) =>{
    try {
        const response = await request.put('Venta/UpdateCotizacion',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;  
    } catch (error) {
        return error;
    }
}

petitions.deleteCotizacion = async (idEmpresa,token, data) =>{
    try {
        const response = await request.delete('Archivo/DeleteCotizacion',{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
            data: data
        })
        return response.data;       
    } catch (error) {
        return error;
    }   
}

petitions.insertCompra = async (idEmpresa, token, data, file) => {
    try {

        const formData = new FormData();

        formData.append(
            'obj',
            JSON.stringify({
                compra: {
                    ...data.compra
                },
                detalleCompra: data.detalleCompra
            })
        );

        if (file) {
            formData.append(
                'archivo',
                file
            );
        }

        const response = await request.post(
            'Compra/RegisterCompra',
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                params: {
                    idEmpresa: idEmpresa
                }
            }
        );

        return response.data;

    } catch (error) {
        return error;
    }
}

petitions.getCompras = async (idEmpresa,token, fInicio, fFin) => {
    try {
        const response = await request.get('Compra/GetCompras', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa,
                fInicio: fInicio,
                fFin: fFin
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getCompra = async (idEmpresa, token, idCompra) => {
    try {

        const response = await request.get(
            'Compra/GetCompra',
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                params: {
                    idEmpresa: idEmpresa,
                    idCompra: idCompra
                }
            }
        );

        return response.data;

    } catch (error) {
        return error;
    }
}

petitions.updateCompra = async (
    idEmpresa,
    token,
    data,
    file,
    eliminarArchivo
) => {
    try {
        const formData = new FormData();

        formData.append(
            'obj',
            JSON.stringify({
                    compra: {
                    ...data.compra
                },
                detalleCompra: data.detalleCompra,
                eliminarArchivo: eliminarArchivo
            })
        );

        if (file) {
            formData.append('archivo', file);
        }

        const response = await request.put(
            'Compra/UpdateCompra',
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                params: {
                    idEmpresa
                }
            }
        );

        return response.data;
    } catch (error) {
        return error;
    }
};

petitions.deleteCompra = async (idEmpresa,token, data) =>{
    try {
        const response = await request.delete('Archivo/DeleteCompra',{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
            data: data
        })
        return response.data;       
    } catch (error) {
        return error;
    }   
}

petitions.getTipTraslado = async (idEmpresa,token) => {
    try {
        const response = await request.get('Archivo/GetTipTraslado', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa,
            },
        });
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.getConductor = async (idEmpresa,token) => {
    try {
        const response = await request.get('Archivo/GetConductores', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
        });
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.insertEntrada = async (idEmpresa,token,data) => {
    try {
        const response = await request.post('Inventario/RegisterEntrada',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.insertSalida = async (idEmpresa,token,data) => {
    try {
        const response = await request.post('Inventario/RegisterSalida',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getInventario = async (idEmpresa,token, fInicio, fFin) => {
    try {
        const response = await request.get('Inventario/GetInventario', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa,
                fInicio: fInicio,
                fFin: fFin
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getGuiasRemision = async (idEmpresa,token, fInicio, fFin) => {
    try {
        const response = await request.get('Inventario/GetGuiasRemision', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa,
                fInicio: fInicio,
                fFin: fFin
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getEntrada = async (idEmpresa,token, id) => {
    try {
        const response = await request.get('Inventario/GetEntrada', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: { idEmpresa, id },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getSalida = async (idEmpresa,token, id) => {
    try {
        const response = await request.get('Inventario/GetSalida', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: { idEmpresa, id },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.updateEntrada = async (idEmpresa,token,data) => {
    try {
        const response = await request.put('Inventario/UpdateEntrada',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.updateSalida = async (idEmpresa,token,data) => {
    try {
        const response = await request.put('Inventario/UpdateSalida',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.anularVenta = async (idEmpresa, token, data) => {
    try {
        const response = await request.post('Venta/AnularVenta',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.anularCompra = async (idEmpresa, token, data) => {
    try {
        const response = await request.post('Compra/AnularCompra',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getSalida = async (idEmpresa,token, id) => {
    try {
        const response = await request.get('Inventario/GetSalida', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: { idEmpresa, id },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getMotivoNota = async (idEmpresa,token, tipo) => {
    try {
        const response = await request.get('Venta/GetMotivoN', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: { idEmpresa, tipo },
        });
        return response.data;
    } catch (error) {
        return error;   
    }
}

petitions.registerNota = async (idEmpresa,token, data) => {
    try {
        const response = await request.post('Venta/RegisterNota',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;
    } catch (error) {
        return error;   
    }
}

petitions.informarVenta = async (idEmpresa,token, idVenta) => {
    try {
        const response = await request.post('Service/InformarVenta',{},{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: { idEmpresa, idVenta }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getXmlVenta = async (idEmpresa,token, idVenta) => {
    try {
        const response = await request.get('Service/GetXmlVenta', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: { idEmpresa, idVenta },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.informarNota = async (idEmpresa,token, idVenta) => {
    try {
        const response = await request.post('Service/InformarNota',{},{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa,
                idVenta: idVenta
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getXmlNota = async (idEmpresa,token, idVenta) => {
    try {
        const response = await request.get('Service/GetXmlNota', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: { idEmpresa, idVenta },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getInforme = async (idEmpresa,token, idVenta) => {
    try {
        const response = await request.get('Venta/GetInforme', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: { idEmpresa, idVenta },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getCdrVenta = async (idEmpresa,token, idVenta) => {
    try {
    const response = await request.get('Service/GetCdrVenta', {
      headers: {
        'Authorization': `Bearer ${token}`
      },
      params: { idEmpresa, idVenta },
      responseType: 'blob'
    });

    const contentType = response.headers['content-type'];

    if (contentType.includes("application/json")) {
      const text = await response.data.text();
      const json = JSON.parse(text);
      return { isError: true, ...json };
    }

    return { isError: false, blob: response.data };

  } catch (error) {
    return { isError: true, message: "Error de red o del servidor", error };
  }
}

petitions.updateUsuario = async (token,data) => {
    try {
        const response = await request.put('Usuario/UpdateUsuario',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        })
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.updateEmpresa = async (token,data) => {
    try {
        const response = await request.put('Empresa/UpdateEmpresa',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        })
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.getReportVenta = async (idEmpresa,token, idVenta) => {
  try {
    const response = await request.get('Reports/GetReportVenta', {
      headers: {
        'Authorization': `Bearer ${token}`
      },
      params: { idEmpresa, idVenta },
      responseType: 'blob'
    });

    const contentType = response.headers['content-type'];

    if (contentType.includes("application/json")) {
      const text = await response.data.text();
      const json = JSON.parse(text);
      return { isError: true, ...json };
    }

    return { isError: false, blob: response.data };

  } catch (error) {
    return { isError: true, message: "Error de red o del servidor", error };
  }
}

petitions.getReportCotizacion = async (idEmpresa,token, idVenta) => {
  try {
    const response = await request.get('Reports/GetReportCotizacion', {
      headers: {
        'Authorization': `Bearer ${token}`
      },
      params: { idEmpresa, idVenta },
      responseType: 'blob'
    });

    const contentType = response.headers['content-type'];

    if (contentType.includes("application/json")) {
      const text = await response.data.text();
      const json = JSON.parse(text);
      return { isError: true, ...json };
    }

    return { isError: false, blob: response.data };

  } catch (error) {
    return { isError: true, message: "Error de red o del servidor", error };
  }
}

petitions.getReportCompra = async (idEmpresa,token, idCompra) => {
  try {
    const response = await request.get('Reports/GetReportCompra', {
      headers: {
        'Authorization': `Bearer ${token}`
      },
      params: { idEmpresa, idCompra },
      responseType: 'blob'
    });

    const contentType = response.headers['content-type'];

    if (contentType.includes("application/json")) {
      const text = await response.data.text();
      const json = JSON.parse(text);
      return { isError: true, ...json };
    }

    return { isError: false, blob: response.data };

  } catch (error) {
    return { isError: true, message: "Error de red o del servidor", error };
  } 
}

petitions.getReportEntrada = async (idEmpresa,token, idCompra) => {
  try {
    const response = await request.get('Reports/GetReportEntrada', {
      headers: {
        'Authorization': `Bearer ${token}`
      },
      params: { idEmpresa, idCompra },
      responseType: 'blob'
    });

    const contentType = response.headers['content-type'];

    if (contentType.includes("application/json")) {
      const text = await response.data.text();
      const json = JSON.parse(text);
      return { isError: true, ...json };
    }

    return { isError: false, blob: response.data };

  } catch (error) {
    return { isError: true, message: "Error de red o del servidor", error };
  } 
}

petitions.getReportSalida = async (idEmpresa,token, idVenta) => {
  try {
    const response = await request.get('Reports/GetReportSalida', {
      headers: {
        'Authorization': `Bearer ${token}`
      },
      params: { idEmpresa, idVenta },
      responseType: 'blob'
    });

    const contentType = response.headers['content-type'];

    if (contentType.includes("application/json")) {
      const text = await response.data.text();
      const json = JSON.parse(text);
      return { isError: true, ...json };
    }

    return { isError: false, blob: response.data };

  } catch (error) {
    return { isError: true, message: "Error de red o del servidor", error };
  }   
}

petitions.sendEmailVenta = async (idEmpresa,token, idVenta, email) => {
    try {
        const response = await request.post('Service/SendVentaReportEmail', {}, {
            headers: {
                'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
            },
            params: { idEmpresa, idVenta, email },
        });
        return response.data;
    } catch (error) {
        return error;       
    }
}

petitions.sendEmailCompra = async (idEmpresa,token, idCompra, email) => {
    try {
        const response = await request.post('Service/SendCompraReportEmail', {}, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: { idEmpresa, idCompra, email },
        });
        return response.data;
    } catch (error) {
        return error;       
    }
}

petitions.getTotalesResumen = async (idEmpresa,token) => {
    try {
        const response = await request.get('Home/GetTotalesResumen', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: { idEmpresa},
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getVentas7dias = async (idEmpresa,token) => {
    try {
        const response = await request.get('Home/GetVentasUltimos7Dias', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: { idEmpresa},
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getMovTotalesMesActual = async (idEmpresa,token) => {
    try {
        const response = await request.get('Home/GetMovimientosTotalesMesActual', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: { idEmpresa},
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getTotalComprasVentasMesPasado = async (idEmpresa,token) => {
    try {
        const response = await request.get('Home/GetTotalCVMesPasado', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: { idEmpresa},
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getProductosMasVendidos = async (idEmpresa,token) => {
    try {
        const response = await request.get('Home/GetProductosMasVendidos', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: { idEmpresa},
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.bloquearCliente = async (idEmpresa, token, data) => {
    try {
        const response = await request.put('Clientes/BloquearCliente',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa
            }
        })
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.getSeries = async (idEmpresa, token) => {
    try {
        const response = await request.get('Archivo/GetSeries', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: { idEmpresa},
        });
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.insertSerie = async (idEmpresa, token,data) => {
    try {
        const response = await request.post('Archivo/InsertSerie',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.updateSerie = async (idEmpresa, token,data) => {
    try {
        const response = await request.put('Archivo/UpdateSerie',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.deleteSerie = async (idEmpresa, token,data) => {
    try {
        const response = await request.delete('Archivo/DeleteSerie',{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
            data: data
        })
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.getComprobantes = async (idEmpresa, token) => {
    try {
        const response = await request.get('Archivo/GetComprobantes', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {idEmpresa},
        });
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.getReportTicket = async (idEmpresa, token, id) => {
    try {
    const response = await request.get('Reports/GetReporTicket', {
      headers: {
        'Authorization': `Bearer ${token}`
      },
      params: { idEmpresa, id },
      responseType: 'blob'
    });

    const contentType = response.headers['content-type'];

    if (contentType.includes("application/json")) {
      const text = await response.data.text();
      const json = JSON.parse(text);
      return { isError: true, ...json };
    }

    return { isError: false, blob: response.data };

  } catch (error) {
    return { isError: true, message: "Error de red o del servidor", error };
  }
}

petitions.insertConductor = async (idEmpresa, token,data) => {
    try {
        const response = await request.post('Archivo/RegisterConductor',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.updateConductor = async (idEmpresa, token,data) => {
    try {
        const response = await request.put('Archivo/UpdateConductor',data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            }
        })
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.deleteConductor = async (idEmpresa, token,data) => {
    try {
        const response = await request.delete('Archivo/DeleteConductor',{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: {
                idEmpresa: idEmpresa
            },
            data: data
        })
        return response.data;       
    } catch (error) {
        return error;
    }
}

petitions.getReporteVentasDiaSemanaMes = async (idEmpresa, token, fInicio, fFin) => {
    try {
        const response = await request.get('Reports/GetReporteVentasDiaSemanaMes', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: { idEmpresa, fInicio, fFin },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getGetReporteComprasDiaSemanaMes = async (idEmpresa, token, fInicio, fFin) => {
    try {
        const response = await request.get('Reports/GetReporteCompras_DiaSemanaMes', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: { idEmpresa, fInicio, fFin },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getGetReporteVentasComprasMoneda = async (idEmpresa, token, fInicio, fFin) => {
    try {
        const response = await request.get('Reports/GetReporteVentasComprasMoneda', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: { idEmpresa, fInicio, fFin },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getGetReporteVentasComprasMonedaUser = async (idEmpresa, token, fInicio, fFin, idUsuario) => {
    try {
        const response = await request.get('Reports/GetReporteVentasComprasMonedaUser', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: { idEmpresa, fInicio, fFin, idUsuario },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

petitions.getGetReporteVentasDiaSemanaMesUser = async (idEmpresa, token, fInicio, fFin, idUsuario) => {
    try {
        const response = await request.get('Reports/GetReporteVentasDiaSemanaMesUser', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            params: { idEmpresa, fInicio, fFin, idUsuario },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}


petitions.importProductos = async (idEmpresa, token, archivo) => {
    try {

        const formData = new FormData();
        formData.append("archivo", archivo);

        const response = await request.post(
            "Productos/ImportarProductos",
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`
                },
                params: {
                    idEmpresa
                }
            }
        );

        return response.data;

    } catch (error) {
        return error;
    }
}

petitions.importClientes = async (idEmpresa, token, archivo) => {
    try {

        const formData = new FormData();
        formData.append("archivo", archivo);

        const response = await request.post(
            "Clientes/ImportarClientes",
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`
                },
                params: {
                    idEmpresa
                }
            }
        );

        return response.data;

    } catch (error) {
        return error;
    }
}

petitions.getPlantillaImportacion = async (token, tipo) => {
    try {
        const response = await request.get(
            "Reports/GetPlantillaImportacion",
            {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                params: {
                    tipo
                },
                responseType: "blob"
            }
        );

        const contentType = response.headers["content-type"];

        if (contentType.includes("application/json")) {
            const text = await response.data.text();
            const json = JSON.parse(text);
            return { isError: true, ...json };
        }

        return {
            isError: false,
            blob: response.data
        };

    } catch (error) {
        return {
            isError: true,
            message: "Error de red o del servidor",
            error
        };
    }
};